import React from 'react';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import { Search as SearchIcon, Close as CloseIcon } from '@mui/icons-material';
import { FIELD_STYLES } from './fieldStyles';

export const searchFunction = (data, searchBy, searchValue) => {
  const result = [];
  for (let i = 0; i < data?.length; i++) {
    const element = data[i];
    for (const field of searchBy) {
      const searchTerm = searchValue.toLowerCase();
      const elementValue =
        typeof element[field] === 'string'
          ? element[field].toLowerCase()
          : element[field];
      if (typeof elementValue === 'string') {
        if (elementValue.includes(searchTerm)) {
          result.push(element);
          break;
        }
      } else {
        if (elementValue === searchTerm) {
          result.push(element);
          break;
        }
      }
    }
  }
  return result;
};

const SearchBar = ({
  placeholder,
  value,
  onChange,
  clearSearch,
  width = 400,
  sx,
}) => {
  return (
    <TextField
      variant="outlined"
      placeholder={placeholder || 'Search...'}
      value={value}
      onChange={onChange}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start" sx={{ mr: 1 }}>
            <SearchIcon sx={{ color: 'text.secondary', fontSize: 20 }} />
          </InputAdornment>
        ),
        endAdornment: value ? (
          <InputAdornment position="end">
            <IconButton size="small" onClick={clearSearch} edge="end">
              <CloseIcon sx={{ fontSize: 18 }} />
            </IconButton>
          </InputAdornment>
        ) : null,
      }}
      sx={{
        width,
        '& .MuiOutlinedInput-root': {
          minHeight: FIELD_STYLES.minHeight,
        },
        '& .MuiOutlinedInput-input': {
          fontSize: FIELD_STYLES.fontSize,
          lineHeight: FIELD_STYLES.lineHeight,
          padding: `${FIELD_STYLES.paddingY} ${FIELD_STYLES.paddingX}`,
        },
        ...sx,
      }}
    />
  );
};

export default SearchBar;
